import { useDroppable } from '@dnd-kit/core';
import { cn } from '@/lib/utils';
import { KanbanLane, KanbanLaneEmpty } from '@/ui/primitives';
import type { CardFieldMap, KanbanColumn as Column } from '../types';
import { KanbanCard } from './KanbanCard';

interface Props {
  column: Column;
  fieldMap: CardFieldMap;
  onCardSelect: (cardId: string) => void;
  /** Destaca a coluna (ex.: pipe ativo) com anel verde. */
  featured?: boolean;
  /** Quando difere de count, exibe badge "count/total". */
  totalCount?: number | undefined;
  /** Reduz o destaque visual dos cards em etapas encerradas. */
  cardsMuted?: boolean;
}

// Coluna do pipeline = KanbanLane do design system. A lógica de drop (dnd) e o
// destaque "featured" ficam aqui; o estilo base vem do primitivo.
export function KanbanColumn({
  column,
  fieldMap,
  onCardSelect,
  featured,
  totalCount,
  cardsMuted = false,
}: Props) {
  const { setNodeRef, isOver } = useDroppable({ id: column.id });
  const count = column.processos.length;
  const badgeLabel = totalCount != null && totalCount !== count ? `${count}/${totalCount}` : count;

  return (
    <KanbanLane
      ref={setNodeRef}
      data-pan-skip
      title={column.nome}
      count={badgeLabel}
      isOver={isOver}
      className={cn(
        featured && !isOver && 'ring-2 ring-[color-mix(in_oklab,var(--ok)_45%,transparent)]',
      )}
    >
      {count === 0 ? (
        <KanbanLaneEmpty>{isOver ? 'Soltar aqui' : 'Vazia'}</KanbanLaneEmpty>
      ) : (
        column.processos.map((card) => (
          <KanbanCard
            key={card.id}
            card={card}
            fieldMap={fieldMap}
            muted={cardsMuted}
            onSelect={() => onCardSelect(card.id)}
          />
        ))
      )}
    </KanbanLane>
  );
}
